<template>
    <div class="footer">
        <div class="cus-row">
            <div class="cus-row-col-in-5" @click="showlist">
                <div class="t-al-c"><van-icon name="wap-home-o" size="0.44rem"/></div>
                <div class="t-al-c" style="margin-top: .1rem"><span class="ffr s-20-28 f-c-b5b5b5">首页</span></div>
            </div>
            <div class="cus-row-col-in-5" @click="showDone">
                <div class="t-al-c"><van-icon name="orders-o" size="0.44rem"/></div>
                <div class="t-al-c" style="margin-top: .1rem"><span class="ffr s-20-28 f-c-b5b5b5">列表</span></div>
            </div>
            <div class="cus-row-col-in-5" style="position: relative">
                <div class="add-btn f-c-000000" style="color:#ffffff !important;background-color: #0a0701" @click="addNew">
                    <span class="ab-t-t-x-y">
                        <van-icon name="plus" size="0.32rem"/>
                    </span>
                </div>
                <div class="t-al-c"><span class="ffr s-20-28 f-c-b5b5b5">新增合同</span></div>
            </div>
            <div class="cus-row-col-in-5" @click="showqr">
                <div class="t-al-c"><van-icon name="qr" size="0.44rem"/></div>
                <div class="t-al-c" style="margin-top: .1rem"><span class="ffr s-20-28 f-c-b5b5b5">员工管理</span></div>
            </div>
            <div class="cus-row-col-in-5" @click="showhome">
                <div class="t-al-c"><van-icon name="user-o" size="0.44rem"/></div>
                <div class="t-al-c" style="margin-top: .1rem"><span class="ffr s-20-28 f-c-b5b5b5">我的</span></div>
            </div>
        </div>

        <div
            v-if="owner_delegate_show"
            style="position: fixed; top: 0; bottom: 0; left: 0; right: 0; z-index: 99999;"
            class="t-al-c"
        >
            <div style="position: absolute; background: rgba(26, 26, 26, 0.85); top: 0; right: 0; left: 0; bottom: 0;"></div>
            <div class="ab-t-t-x-y" style="width: 300px; min-height: 100px; background: #ffffff; border-radius: 12px; overflow: hidden;">
                <div style="z-index: 2003">
                    <div class="van-dialog__header" style="font-size: 14px;">选择模板类型</div>
                    <div class="van-dialog__content">
                        <div style="margin: 20px 0; padding: 0 20px">
                            <van-radio-group v-model="contract_type">
                                <van-radio name="A00001" style="margin-bottom: 12px; font-size: 14px;">境内游合同</van-radio>
                                <van-radio name="C00001" style="margin-bottom: 12px; font-size: 14px;">出境游合同</van-radio>
                                <van-radio name="E00001" style="font-size: 14px;">代订代办合同</van-radio>
                            </van-radio-group>
                        </div>
                    </div>
                    <div class="van-hairline--top van-dialog__footer van-dialog__footer--buttons">
                        <button class="van-button van-button--default van-button--large van-dialog__cancel" @click="cancelSetDelegate">
                            <span class="van-button__text">取消</span>
                        </button>
                        <button class="van-button van-button--default van-button--large van-dialog__confirm van-hairline--left" @click="confirmSetDelegate">
                            <span class="van-button__text">确认</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import common from '@/assets/js/common'
import { createJob } from '@/assets/js/api'

export default {
    data() {
        return {
            owner_delegate_show: false,
            contract_type: '',
        }
    },
    methods: {
        cancelSetDelegate() {
            this.owner_delegate_show = false
        },
        confirmSetDelegate() {
            if (!this.contract_type) {
                common.mAlert(this, '请选择模板')
                return
            }
            this.owner_delegate_show = false
            createJob({ contract_type: this.contract_type }).then((res) => {
                if (res.errcode == 0) {
                    this.$router.push({ path: 'new_invoice?id=' + res.data })
                }
            })
        },
        addNew() {
            this.contract_type = ''
            this.owner_delegate_show = true
        },
        showqr() {
            this.$router.push({ path: 'invoice' })
        },
        showlist() {
            this.$router.push({ path: 'payment' })
        },
        showhome() {
            this.$router.push({ path: 'mine' })
        },
        showDone() {
            this.$router.push({ path: 'service' })
        },
    },
}
</script>

<style scoped>
.footer {
    position: fixed;
    z-index: 99;
    left: 0;
    right: 0;
    bottom: 0;
    box-shadow: 0.03rem -0.05rem 0.43rem 0.02rem rgba(0, 0, 0, 0.06);
    padding: 0.12rem 0;
    background-color: #ffffff;
}
.add-btn {
    position: absolute;
    width: 0.8rem;
    height: 0.8rem;
    background-color: #1889f9;
    box-shadow: 0.03rem 0.05rem 0.43rem 0.02rem rgba(24, 137, 249, 0.24);
    border-radius: 0.6rem;
    left: 50%;
    transform: translateX(-50%);
    bottom: .4rem;
}
</style>
